
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'

export default {
name: "generateform",
components: {
XHeader,Group,Selector
},
data() {
return {
title: "生成新生报到单",
stuinfo:{
name:'张三',
sex:'男',
year:'2007',
idcard:'11000000000000000',
depart:'XX学院',
major:'XX自动化',
class:'1701',
},
feelist:[
{
feetype:"X费",
feevalue:"18000"
},
{
feetype:"X本费",
feevalue:"1000"
},{
feetype:"X检费",
feevalue:"100"
},{
feetype:"X训费",
feevalue:"200"
},
],
}
},
methods:{
share(){
var _this = this;

}
}
}



// WEBPACK FOOTER //
// ./src/components/newstu/generateform.vue